import React, {useContext} from 'react';
import {roadContext} from "context/roadContext";

const UseContext = () => {
    return (
        useContext(roadContext)
    );
};

export default UseContext;